import { getView, requireAuth } from '@/lib/utils';
import Left from '@/models/Menu/menus/left';
import { AlertDetailsPage } from '@/data/appInformationItems';

export default {
  path: '/alerts/:_key',
  name: 'alert',
  component: getView('pages/PageAlert'),
  redirect: { name: 'alert-details' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'alert-details',
      component: getView('alerts/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Alert > Details',
        leftMenu: Left.AlertDetails,
        information: AlertDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'contacts',
      name: 'alert-contacts',
      component: getView('alerts/TabContacts'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Alert > Contacts',
        leftMenu: Left.AlertDetails,
        information: AlertDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'jobs',
      name: 'alert-jobs',
      component: getView('alerts/TabJobs'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Alert > Jobs',
        leftMenu: Left.AlertDetails,
        information: AlertDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'timeline',
      name: 'alert-timeline',
      component: getView('alerts/TabTimeline'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Alert > Timeline',
        leftMenu: Left.AlertDetails,
        information: AlertDetailsPage,
        showBottomMenu: true,
      },
    },
  ],
};
